module.exports = __webpack_public_path__ + "img/Sturgeon-Point-Lighthouse.ceb75077.jpg";